export default __webpack_public_path__ + "static/media/cleanD.a1a08028.jpg";